import React, { useState } from 'react';
import { LoginIcon } from '@heroicons/react/solid';
import {
  create_signed_opt_in_txn,
  send_txn,
} from '../../../Functions/operations';
import AlgoSigner from '../../../Functions/AlgoSigner';
import {
  updateOptInStepPassedNR,
  updateOptedInNRAddress,
} from '../../../reducer';
import { useAppDispatch } from '../../../hooks';

const app_id = 53291468;

export default function OptIn() {
  const dispatch = useAppDispatch();

  const [connected, setConnected] = useState(false);
  const [error, setError] = useState({ error: false, message: '' });
  const [accounts, setAccounts] = useState([{ address: '' }]);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [feedSelection, setFeedSelection] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  const handleOptIn = async () => {
    let tx_id = '';
    try {
      if (selectedAddress != '') {
        const optInTxnID = await create_signed_opt_in_txn(
          selectedAddress,
          app_id
        );
        tx_id = await send_txn(optInTxnID);
      }
    } catch (error: any) {
      setError({ error: true, message: error.message });
    }
    if (tx_id.length > 0) {
      setConfirmed(true);
    }
  };

  const handleConnect = () => {
    if (AlgoSigner) {
      AlgoSigner.connect().then(async () => {
        const accts = await AlgoSigner.accounts({ ledger: 'TestNet' });
        setAccounts(accts);
        setSelectedAddress(accts[0].address);
        setConnected(true);
        dispatch(updateOptInStepPassedNR(true));
        dispatch(updateOptedInNRAddress(accts[0].address));
      });
    } else {
      setError({
        error: true,
        message:
          'Cannot connect, check Algosigner is installed and configured correctly ',
      });
      dispatch(updateOptInStepPassedNR(false));
    }
  };

  return (
    <div style={{ minHeight: '35em' }}>
      <div className="container w-full mx-auto overflow-hidden">
        <h1>
          Before you can subscribe, you must opt in your account to the smart
          contract.
        </h1>
        {!connected && (
          <button
            onClick={handleConnect}
            type="button"
            className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Connect
            <LoginIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
          </button>
        )}
        {error.error && (
          <p className="text-red-500 italic text-sm"> {error.message} </p>
        )}
        {connected && (
          <>
            <div className="mt-10">
              <label
                htmlFor="location"
                className="block text-sm font-medium text-gray-700"
              >
                Select Account
              </label>
              <select
                onChange={(e) => {
                  setSelectedAddress(e.target.value);
                  dispatch(updateOptedInNRAddress(e.target.value));
                }}
                id="location"
                name="location"
                className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                defaultValue=""
              >
                {accounts.map((acct, key) => {
                  return <option key={key}> {acct.address} </option>;
                })}
              </select>
            </div>
            {confirmed && <h3 className="my-1 text-green-700">Success!</h3>}
            {!confirmed && (
              <button
                onClick={handleOptIn}
                type="button"
                className=" mt-5 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Opt In
                <LoginIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" />
              </button>
            )}
            <div className="mt-10">
              <label
                htmlFor="location"
                className="block text-sm font-medium text-gray-700"
              >
                Select Feed to subscribe to
              </label>
              <select
                onChange={(e) => setFeedSelection(e.target.value)}
                id="location"
                name="location"
                className="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                defaultValue=""
              >
                <option> Cryptocurrency Prices </option>
                <option> Weather Conditions </option>
              </select>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
